module.exports = __webpack_public_path__ + "static/media/aeps.a52bdfed.svg";